import React, {useEffect, useRef} from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import StructuredText from "../custom-structured-text-renderer";

gsap.registerPlugin(ScrollTrigger);

const StatsItem = ({items}) => {
    const itemsRef = useRef()

    useEffect(() => {
        const statsItems = itemsRef?.current?.querySelectorAll(".stats-item__item");

        const animation = () => {
            statsItems.forEach((el, i) => {
                gsap.to(el, {
                    x: 0,
                    opacity: 1,
                    duration: 0.3,
                    ease: 'power1.inOut',
                    delay: i * 0.2
                });
            });
        }

        ScrollTrigger.create({
            trigger: '.stats-item',
            start: "top bottom",
            onEnter: animation,
        });

        return () => {
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, [items]);

    return (
        <section className='stats-item' ref={itemsRef}>
            <div className='stats-item__inner'>
                <div className='stats-item__items'>
                    {
                        items?.length > 0 && items.map((el, i) => (
                            <div key={i} className='stats-item__item'>
                                {el.stat && <h3>{parse(el.stat)}</h3>}
                                {el.richContent && <StructuredText data={el.richContent}/>}
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    )
}

export default StatsItem

export const query = graphql`
fragment StatsItemProps on DatoCmsStatsItem {
  ... on DatoCmsStatsItem {
    id
    items {
      stat
      richContent {
        value
      }
    }
  }
}
`